export default {
  BEHAVIORAL_HEALTH_PARAGRAPH_ONE:
    'Behavioral Health (Connect Care) can see patients 18+ with mild to moderate cases of the following conditions:',
  BEHAVIORAL_HEALTH_CONDITIONS: [
    'Anxiety',
    'Depression',
    'Attention Deficit',
    'Stress',
    'Addiction or Substance Misuse/Abuse',
    'Bipolar',
    'Anger or Mood Swings',
    'Panic Attacks',
    'Insomnia',
    'PTSD'
  ],
  BEHAVIORAL_HEALTH_PARAGRAPH_TWO:
    'If you are currently in treatment, contact your provider.  If you don’t feel safe, contact the crisis line, go to your nearest Emergency Department, or call 911.',
  BEHAVIORAL_HEALTH_PARAGRAPH_THREE:
    'If you select a same-day visit please expect a call from our Patient Services Representative to complete your check-in process. Depending on your patient status and any change in insurance, we may request you complete and return informational forms prior to your visit.'
};
